<script setup lang="ts">
import type { PropType } from 'vue'
defineProps({
  pending: {
    type: Boolean,
    default: false,
  },
  stops: {
    type: Array as PropType<{ id: string }[]>,
  },
})
</script>

<template>
  <div class="stop-list">
    <SkeletonTable v-if="pending" />
    <ul v-else-if="stops">
      <li v-for="stop in stops" :key="`${stop.id}`">
        <StopCard :stop="stop" />
      </li>
    </ul>
  </div>
</template>
